export default "__VITE_ASSET__BCLN3BNb__"